/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_TenantDto } from '../models/PagedResultDto_TenantDto';
import type { Volo_Abp_TenantManagement_TenantCreateDto } from '../models/Volo_Abp_TenantManagement_TenantCreateDto';
import type { Volo_Abp_TenantManagement_TenantDto } from '../models/Volo_Abp_TenantManagement_TenantDto';
import type { Volo_Abp_TenantManagement_TenantUpdateDto } from '../models/Volo_Abp_TenantManagement_TenantUpdateDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TenantService {

    /**
     * @param id
     * @returns Volo_Abp_TenantManagement_TenantDto OK
     * @throws ApiError
     */
    public static getApiAwardApiMultiTenancyTenants(
        id: string,
    ): CancelablePromise<Volo_Abp_TenantManagement_TenantDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/multi-tenancy/tenants/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param requestBody
     * @returns Volo_Abp_TenantManagement_TenantDto OK
     * @throws ApiError
     */
    public static putApiAwardApiMultiTenancyTenants(
        id: string,
        requestBody?: Volo_Abp_TenantManagement_TenantUpdateDto,
    ): CancelablePromise<Volo_Abp_TenantManagement_TenantDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/multi-tenancy/tenants/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAwardApiMultiTenancyTenants(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/multi-tenancy/tenants/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter
     * @param sorting
     * @param skipCount
     * @param maxResultCount
     * @returns PagedResultDto_TenantDto OK
     * @throws ApiError
     */
    public static getApiAwardApiMultiTenancyTenants1(
        filter?: string,
        sorting?: string,
        skipCount?: number,
        maxResultCount?: number,
    ): CancelablePromise<PagedResultDto_TenantDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/multi-tenancy/tenants',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody
     * @returns Volo_Abp_TenantManagement_TenantDto OK
     * @throws ApiError
     */
    public static postApiAwardApiMultiTenancyTenants(
        requestBody?: Volo_Abp_TenantManagement_TenantCreateDto,
    ): CancelablePromise<Volo_Abp_TenantManagement_TenantDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/multi-tenancy/tenants',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiMultiTenancyTenantsDefaultConnectionString(
        id: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/multi-tenancy/tenants/{id}/default-connection-string',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @param defaultConnectionString
     * @returns any OK
     * @throws ApiError
     */
    public static putApiAwardApiMultiTenancyTenantsDefaultConnectionString(
        id: string,
        defaultConnectionString?: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/multi-tenancy/tenants/{id}/default-connection-string',
            path: {
                'id': id,
            },
            query: {
                'defaultConnectionString': defaultConnectionString,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id
     * @returns any OK
     * @throws ApiError
     */
    public static deleteApiAwardApiMultiTenancyTenantsDefaultConnectionString(
        id: string,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/award/api/multi-tenancy/tenants/{id}/default-connection-string',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
